<template>
  <v-dialog persistent width="min(700px, 97%)" :value="dialog">
    <v-card class="pa-8">
      <template v-if="userData">
        <v-card-title class="form-header">Подтвердите Ваши данные</v-card-title>
        <v-card-subtitle>Их всегда можно изменить в личном кабинете</v-card-subtitle>
        <v-row no-gutters class="pa-6">

          <v-col cols="12">
            <v-text-field
              label="Вас пригласил"
              :value="userData.invitation_partner.name"
              disabled
              dense
            ></v-text-field>
          </v-col>

          <v-col cols="12">
            <v-text-field
              label="Ваш номер телефона"
              :value="formattedPhone"
              disabled
              dense
            ></v-text-field>
          </v-col>

          <v-col cols="12" v-for="(value, key) in userInfo">
            <v-text-field
              :label="aliases[key]"
              :value="(key === 'type' || key === 'reward_type') ? aliases[value] || value : value"
              disabled
              dense
            ></v-text-field>
          </v-col>
        </v-row>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="secondary"
            text
            @click="dialog = false"
          >
            Отклонить
          </v-btn>

          <v-btn
            color="primary"
            text
            @click="
            acceptData();
            dialog = false;
            "
          >
            Принять
          </v-btn>
        </v-card-actions>
      </template>
      <template v-else>
        <v-card-title class="form-header">Данные приглашения не найдены</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="dialog = false"
          >
            ОК
          </v-btn>
        </v-card-actions>
      </template>
    </v-card>
  </v-dialog>
</template>

<script>
import { getInviteData } from "@/api/invite";
import { formatPhone } from "@/utils/helpers";

export default {
  name: "AcceptInvitePopup",
  props: ["inviteId"],
  data() {
    return {
      dialog: true,
      aliases: {
        firstname: "Имя",
        surname: "Фамилия",
        middlename: "Отчество",
        email: "E-mail",
        type: "ОПФ",
        inn: "ИНН",
        reward_type: "Модель вознаграждения",
        company_name: "Название компании",
        ogrn: "ОГРН",
        IP: "ИП",
        FL: "Физическое лицо",
        UL: "Юридическое лицо",
        RevShare: "Фиксированная ставка + % от коммиссии",
        Progressive: "Прогрессивная ставка",
      },
      userData: {
        invitation_partner: {
          name: null,
        },
        has_password: false,
        data: {
          user: {
            login: null,
          },
          profile: {
            firstname: null,
            surname: null,
            middlename: null,
            email: null,
            type: null,
            inn: null,
            reward_type: null,
            company_name: null,
            ogrn: null
          },
        },
      },
    };
  },
  methods: {
    acceptData() {
      this.$store.commit("registration/setPhone", this.formattedPhone);
      this.$store.commit("registration/setInvitationId", this.inviteId);
    },
  },
  mounted() {
    getInviteData(this.inviteId)
      .then((res) => {
        if (res) this.userData = res;
        else this.userData = null;
      });
  },
  computed: {
    formattedPhone() {
      return formatPhone(this.userData.data.user.login);
    },
    userInfo() {
      const profileInfo = this.userData.data.profile;
      const userInfo = {};
      let key;
      for (key in profileInfo) {
        if (!!profileInfo[key]) userInfo[key] = profileInfo[key];
      }
      return userInfo;
    }
  }
};
</script>

<style lang="scss" scoped>
.form-header {
  word-break: break-word;
}
</style>
